exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-box{width:100%}.address-box>.editable-wrap{width:auto!important}.address-box .address-text{margin-top:10px;height:40px;border:1px solid #ccc;padding:10px}", ""]);

// exports
